(function () {
  if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM_RATIO = 2.4;
  var lens = null;
  var activeImg = null;

  function getLens() {
    if (!lens) {
      lens = document.createElement('div');
      lens.className = 'hl-zoom-lens';
      lens.setAttribute('aria-hidden', 'true');
      document.body.appendChild(lens);
    }
    return lens;
  }

  function hideLens() {
    if (lens) lens.classList.remove('hl-zoom-lens--visible');
    activeImg = null;
  }

  function showLens(img) {
    var el = getLens();
    var src = img.currentSrc || img.src;
    el.style.backgroundImage = 'url("' + src + '")';
    el.classList.add('hl-zoom-lens--visible');
    activeImg = img;
  }

  function moveLens(event, container) {
    var el = getLens();
    var rect = container.getBoundingClientRect();
    var x = event.clientX - rect.left;
    var y = event.clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      hideLens();
      return;
    }

    var xPercent = (x / rect.width) * 100;
    var yPercent = (y / rect.height) * 100;

    el.style.left = event.clientX + 'px';
    el.style.top = event.clientY + 'px';
    el.style.backgroundSize = rect.width * ZOOM_RATIO + 'px ' + rect.height * ZOOM_RATIO + 'px';
    el.style.backgroundPosition = xPercent + '% ' + yPercent + '%';
  }

  function handleMove(gallery, event) {
    var activeSlide = gallery.querySelector('.product__media-item.is-active');
    var container = activeSlide && activeSlide.querySelector('.product-media-container.media-type-image');
    var img = container && container.querySelector('img');

    if (!container || !img) {
      hideLens();
      return;
    }

    if (activeImg !== img) showLens(img);
    moveLens(event, container);
  }

  function attach(gallery) {
    gallery.addEventListener('mousemove', function (event) {
      handleMove(gallery, event);
    });
    gallery.addEventListener('mouseleave', hideLens);
  }

  function init() {
    var galleries = document.querySelectorAll('[data-hl-hover-zoom]');
    galleries.forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
